// extracted by mini-css-extract-plugin
export var border = "_k-8";
export var brand = "_k-t";
export var button = "_k-l";
export var center = "_k-a";
export var centered = "_k-6";
export var closeButton = "_k-c";
export var disabledWrapper = "_k-m";
export var error = "_k-p";
export var extraLarge = "_k-4";
export var extraSmall = "_k-1";
export var fill = "_k-i";
export var footer = "_k-h";
export var footerAction = "_k-j";
export var footerButtons = "_k-k";
export var header = "_k-7";
export var headerWithClose = "_k-d";
export var icon = "_k-o";
export var info = "_k-s";
export var inline = "_k-9";
export var large = "_k-3";
export var main = "_k-e";
export var modal = "_k-0";
export var nearFull = "_k-5";
export var neutral = "_k-u";
export var noPadding = "_k-g";
export var none = "_k-v";
export var scrollable = "_k-f";
export var small = "_k-2";
export var success = "_k-r";
export var tight = "_k-n";
export var titleIcon = "_k-b";
export var warn = "_k-q";